import { CircularProgress } from '@/modules/common/components/CircularProgress/CircularProgress';
import { Box } from '@mui/material';

type Props = {
  block: boolean;
};

export const UIBlockingLoadIndicator = ({ block }: Props) => {

  if (!block) {
    return null;
  }

  return (
    <Box
      position='absolute'
      top={0}
      left={0}
      right={0}
      bottom={0}
      display='flex'
      alignItems='center'
      justifyContent='center'
      bgcolor='rgba(255,255,255,0.6)'
      sx={{ backdropFilter: 'blur(1px)', zIndex: 10 }}
    >
      <CircularProgress size={48} />
    </Box>
  );
  
};
